module.exports = __webpack_public_path__ + "media/images/user-icon-591c9ab30abf7bcb2b304c31e344be9f.svg";